import React from 'react';
import { Icons } from '@miro-site/ui-design-system';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HeaderMenuButton = function HeaderMenuButton(_ref) {
  var title = _ref.title,
      path = _ref.path,
      onMouseEnter = _ref.onMouseEnter,
      onClick = _ref.onClick,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$hasSubMenu = _ref.hasSubMenu,
      hasSubMenu = _ref$hasSubMenu === void 0 ? false : _ref$hasSubMenu;
  var Element = path ? 'a' : 'button';
  return /*#__PURE__*/_jsx("div", {
    className: "py-300 my-n150 py-xl-300",
    children: /*#__PURE__*/_jsxs(Element, {
      className: classNames('text-black d-flex justify-content-between btn btn-sm btn-link gap-50', {
        hover: isActive
      }),
      tabIndex: 0,
      "aria-controls": "product-navigation",
      "aria-expanded": hasSubMenu && isActive || undefined,
      "aria-haspopup": hasSubMenu || undefined,
      "data-top-navigation-button": "1",
      "data-track-id": "top-navigation-button",
      href: path || undefined,
      onClick: onClick || undefined,
      onMouseEnter: onMouseEnter || undefined,
      children: [title, hasSubMenu && /*#__PURE__*/_jsx(Icons.ChevronDown, {
        className: "align-self-center d-none d-xl-flex me-n50",
        size: 200
      })]
    })
  });
};